import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import selectboxEditor from './_datetime_selectbox_editor';

/**
 * 反映予定日時設定モーダルコンポーネント
 */
export default {
    template: '#modal_reservation_datetime_editor_template',
    data() {
        return {
            // 時刻
            datetime: null,
            // 予約日時
            reserve_time: null
        };
    },
    mixins: [commonMixin, modalMixin],
    components: {
        // 静的HTML編集コンポーネント
        'selectbox-editor': selectboxEditor
    },
    emits: ['input'],
    methods: {
        opening: function() {
            this.datetime = moment().format('YYYY/MM/DD HH:mm');
        },
        // 予約日時を親に通知する
        emitInput: function() {
            // フォーマットして通知
            this.$emit(
                'input',
                moment(this.reserve_time, 'YYYY/MM/DD HH:mm').format('YYYYMMDDHHmm')
            );
        }
    }
};
